import { useNavigate } from "react-router-dom";

function CTA() {
  const navigate = useNavigate();

  return (
    <section className="cta">
      <h2>Start Your Tech Journey Today</h2>
      <p>Upgrade your skills and build your future with Codeion.</p>
      <button className="primary" onClick={() => navigate("/pricing")}>Explore Pricing</button>
    </section>
  );
}

export default CTA;
